import React from 'react'

import { twMerge } from 'tailwind-merge'

import LogoVisitMonaco from '@images/logo_visitmonaco.svg?react'

interface PlaceholderProps {
  className?: string
}

const Placeholder: React.FC<PlaceholderProps> = ({ className }) => {
  return (
    <div
      className={twMerge(
        'relative inset-0 z-0 h-full w-full bg-brand-light flex items-center justify-center',
        className,
      )}
    >
      <LogoVisitMonaco
        className="w-[50%] text-brand filter brightness-[90%]"
        aria-label="Visit Monaco"
      />
    </div>
  )
}

export default Placeholder
